import { SearchContentModel } from "../SearchContent/SearchContentModel";

class SearchItemUtils {
  static isArticle = (blok: SearchContentModel) => {
    return blok.full_slug.startsWith("articles/");
  };

  static getButtonLabel = (blok: SearchContentModel): string => {
    if (!blok.content.body) {
      return "";
    }
    if (this.isArticle(blok)) {
      const label = blok.content.body[0]?.categories || "";
      return label as string;
    }
    return blok.name;
  };
}

export default SearchItemUtils;
